'use client';
import React from 'react';
import { ArrowUpRight, ArrowDownLeft, Zap } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


// BACKEND INTEGRATION: Replace with real FFCT transaction feed from Bitcoin network API
const transactions = [
  {
    id: 'tx-001',
    type: 'buy' as const,
    amount: '2,400,000',
    amountUsd: '$888.00',
    from: '1A1zP1...ecc8cBd',
    to: '3FZbgi...LoMpnkS',
    time: '16:05',
    fee: '0.00021',
  },
  {
    id: 'tx-002',
    type: 'sell' as const,
    amount: '850,000',
    amountUsd: '$314.45',
    from: '3J98t1...WiGKTY',
    to: '1BoatSL...uqKoBh',
    time: '15:58',
    fee: '0.00018',
  },
  {
    id: 'tx-003',
    type: 'fee' as const,
    amount: '12,000',
    amountUsd: '$4.44',
    from: '1BpEi6...DjpiSe',
    to: '37t7eX...LazC6',
    time: '15:51',
    fee: '0.00009',
  },
  {
    id: 'tx-004',
    type: 'buy' as const,
    amount: '5,000,000',
    amountUsd: '$1,850.00',
    from: '1GkQmK...TahMnS',
    to: '3QJmnh...x7JCpE',
    time: '15:44',
    fee: '0.00031',
  },
  {
    id: 'tx-005',
    type: 'sell' as const,
    amount: '320,000',
    amountUsd: '$118.40',
    from: '1BvBMSE...WFd8',
    to: '1FeexV...nZJKE',
    time: '15:37',
    fee: '0.00011',
  },
  {
    id: 'tx-006',
    type: 'fee' as const,
    amount: '8,500',
    amountUsd: '$3.14',
    from: '3Nxwenyu...jRhS',
    to: '37t7eX...LazC6',
    time: '15:29',
    fee: '0.00007',
  },
];

const typeConfig = {
  buy: { icon: ArrowDownLeft, color: 'text-green-400', bg: 'bg-green-500/10', label: 'Buy' },
  sell: { icon: ArrowUpRight, color: 'text-red-400', bg: 'bg-red-500/10', label: 'Sell' },
  fee: { icon: Zap, color: 'text-btcgold-400', bg: 'bg-btcgold-500/10', label: 'Fee' },
};

export default function TransactionFeed() {
  return (
    <div className="rounded-xl border border-zinc-800 bg-card p-5">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="text-sm font-semibold text-white">Recent Transactions</h3>
          <p className="text-xs text-zinc-500 mt-0.5">Live FFCT on-chain activity</p>
        </div>
        <span className="badge-active text-xs">Live</span>
      </div>

      <div className="flex flex-col divide-y divide-zinc-800">
        {transactions.map((tx) => {
          const config = typeConfig[tx.type];
          const Icon = config.icon;
          return (
            <div
              key={tx.id}
              className="flex items-center gap-3 py-3 hover:bg-zinc-800/30 -mx-5 px-5 transition-colors duration-150"
            >
              <div className={`w-8 h-8 rounded-lg ${config.bg} flex items-center justify-center flex-shrink-0`}>
                <Icon size={14} className={config.color} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className={`text-xs font-semibold ${config.color}`}>{config.label}</span>
                  <span className="text-xs font-mono text-zinc-500 truncate">
                    {tx.from} → {tx.to}
                  </span>
                </div>
                <div className="flex items-center gap-2 mt-0.5">
                  <span className="text-xs text-zinc-500 font-mono">Fee: {tx.fee} BTC</span>
                </div>
              </div>
              <div className="text-right flex-shrink-0">
                <p className="text-sm font-mono font-semibold text-white">{tx.amountUsd}</p>
                <p className="text-xs font-mono text-zinc-500">{tx.amount} FFCT</p>
              </div>
              <span className="text-xs text-zinc-600 font-mono flex-shrink-0">{tx.time}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}